<template>
    <div>
      <v-container
        fluid
        class="ma-0 pa-0 mb-16 jumbo-header"
        style="background-color: #F9F9F9;"
      >
        <v-row justify="center" align="center" class="fill-height">
          <v-col class="pt-8 pb-16">
            <v-container>
              <back-button
                class="my-8"
                @click.native="$router.go(-1)"
              ></back-button>
              <v-row>
                <v-col cols="12" lg="9">
                  <h2 class="mb-8 home-header-3">
                    Unfortunately you are not eligible to book this vaccination at this time.
                  </h2>
                  <h3>
                    Read more about vaccination eligibility here -
                    <a style="color: #007e93;" href="https://www.nidirect.gov.uk/articles/urgent-menb-vaccination-programme-adolescents-and-young-people">Urgent MenB vaccination for young people</a>.
                  </h3>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import BackButton from '@/components/BackButton';

  export default Vue.extend({
    components: {
      BackButton
    },
    name: 'StepNotEligibleMeningitisBAge',
    mounted() {
      this.$gtag.event('Meningitis B not eligible - age')
    }
  });
  </script>
  